import React, { Fragment, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Breakpoint } from "react-socks";
import { useTranslation } from "react-i18next";
import { utils } from "../../common/utils";
import { LoyaltyProgramTransactionType } from "../../common/enums";
import { getCustomerLoyaltyTransactions } from "../../actions/loyaltyActions";
import LoyaltyTransactionsTable from "./LoyaltyTransactionsTable";

export default function LoyaltyTransactionsList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    dispatch(getCustomerLoyaltyTransactions())
      .then((res) => {
        if (res.value && res.value.status === 200 && res.value.data && res.value.data.items && res.value.data.items.length > 0) {
          setTransactions(res.value.data.items);
        }
      })
      .catch((err) => {
        console.error("Failed to load loyalty transactions", err);
      });
  }, [dispatch]);

  const getNotesText = (item) => {
    if (!item.notes) return "";
    if (item.transactionType === LoyaltyProgramTransactionType.Sale) {
      return t(item.notes) + ": " + item.id;
    }
    return t(item.notes);
  };

  const getTransactionTypeName = (transactionType) => {
    const key = Object.keys(LoyaltyProgramTransactionType).find(
      (k) => LoyaltyProgramTransactionType[k] === transactionType
    );
    return key ? t(key) : transactionType;
  };

  return (
    <Fragment>
      {/* Small screens: card-based list */}
      <Breakpoint small down>
        <div className="accordion padding-top-1x" role="tablist">
          {transactions.length === 0 && (
            <div className="alert alert-info fade show text-center margin-bottom-1x">
              <span className="alert-close" data-dismiss="alert"></span>
              <i className="icon-layers"></i>&nbsp;&nbsp;
              {t("No loyalty transactions found.")}
            </div>
          )}
          {transactions.map((item) => (
            <div className="card" key={item.id}>
              <div className="card-header" role="tab">
                <h6>
                  <span className="text-bold">
                    {getTransactionTypeName(item.transactionType)}
                  </span>
                </h6>
              </div>
              <div className="collapse show" role="tabpanel">
                <div className="card-body form-group">
                  <div className="form-group row align-items-center">
                    <span className="col-4 col-form-label text-right">
                      {t("Transaction Date")}:&nbsp;
                    </span>
                    <span className="text-medium col-8">
                      {utils.dates.getDateString(item.transactionDate)}
                    </span>
                  </div>
                  <div className="form-group row align-items-center">
                    <span className="col-4 col-form-label text-right">
                      {t("Transaction Type")}:&nbsp;
                    </span>
                    <span className="text-medium col-8">
                      {getTransactionTypeName(item.transactionType)}
                    </span>
                  </div>
                  <div className="form-group row align-items-center">
                    <span className="col-4 col-form-label text-right">
                      {t("Balance")}:&nbsp;
                    </span>
                    <span className="text-medium col-8">{item.balance}</span>
                  </div>
                  <div className="form-group row align-items-center">
                    <span className="col-4 col-form-label text-right">
                      {t("Notes")}:&nbsp;
                    </span>
                    <span className="text-medium col-8">
                      {getNotesText(item)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Breakpoint>

      {/* Medium and larger screens: table */}
      <Breakpoint medium up>
        <div className="padding-top-2x mt-2 hidden-lg-up"></div>
        <LoyaltyTransactionsTable transactionsList={transactions} getNotesText={getNotesText} getTransactionTypeName={getTransactionTypeName} />
      </Breakpoint>
    </Fragment>
  );
}
